$(document).on('click', '.y-check.is_btn', function (e) {
	e.preventDefault()
	const is_radio = $('input', this).attr('type') === 'radio'
	const is_checked = $('input', this).prop('checked')
	const name = $('input', this).attr('name')

	if (is_radio) {
		if (is_checked === false) {
			$(`input[name="${ name }"]`)
				.attr('checked', false)
				.parents('.y-check.is_btn')
				.removeClass('is_active')

			$(this).addClass('is_active')
			$('input', this).attr('checked', !is_checked)
		}
	} else {
		$(this).toggleClass('is_active')
		$('input', this).attr('checked', !is_checked)
	}
})
